import React from 'react';

/**
 * Faded placeholder shown when a table value is missing. Matches the muted look
 * established in the main Registration table (`src/components/RegistrationTable.tsx`)
 * so empty Preferred Name / Business Name / Parent / Note cells read the same
 * way across the Registration and Report screens.
 */
export const EmptyValue: React.FC<{ label?: string }> = ({ label = 'None' }) => (
  <span style={{ opacity: 0.4 }}>{label}</span>
);

/**
 * A parent value counts as "empty" when it's blank OR the literal string "none"
 * (case-insensitive) — some customer records store the text "None" rather than a
 * null. Mirrors the check in the main Registration table.
 */
export const isParentEmpty = (parent?: string | null): boolean =>
  !parent || parent.trim().toLowerCase() === 'none';

/** The anonymous walk-in customer is represented by the reserved user id 999999. */
export const ANONYMOUS_USER_ID = 999999;

export const isAnonymousUserId = (userId?: number | null): boolean =>
  userId === ANONYMOUS_USER_ID;
